"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitState = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const __1 = require("..");
const VariableName_1 = require("../VariableName");
exports.unitState = {
    __basic_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'unitState',
    variableName: VariableName_1.VariableName.unitState,
    dbTable: __1.TSDBTable.unitState,
    title: 'Occupancy',
    icon: free_solid_svg_icons_1.faLayerGroup,
    isSlotted: false,
    order: 1,
    colormap: [
        { value: 0, rgb: [98, 170, 16, 1] },
        { value: 0.45, rgb: [220, 190, 25, 1] },
        { value: 0.55, rgb: [220, 190, 25, 1] },
        { value: 1, rgb: [231, 59, 75, 1] },
    ],
    dataPointConverter: x => x * 100,
    unit: '%',
    decimals: 1,
};
//# sourceMappingURL=unit-state.js.map